export default __webpack_public_path__ + "static/media/logoblue.11198fcb.svg";